import { errorToast, toast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useUserRevokeSessionsMutation } from "@/v2-backoffice-client/user/revokeSessions/user.revokeSessions.mutation"
import { USER_REVOKE_SESSIONS_DONE_TITLE } from "@/v2-backoffice-client/user/revokeSessions/user.revokeSessions.constants"

export type UserRevokeSessionsButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  userId: number
  confirmDescription?: string
  onCompleted?(): void
}

function UserRevokeSessionsButton(props: UserRevokeSessionsButtonProps) {
  const { userId, confirmDescription, onCompleted, children, ...rest } = props

  const [revokeSessions, { loading, error }] = useUserRevokeSessionsMutation({
    onCompleted() {
      toast({ variant: "success", title: USER_REVOKE_SESSIONS_DONE_TITLE })
      onCompleted?.()
    },
  })

  errorToast(error, {
    title: "Failed to revoke sessions",
  })

  return (
    <ConfirmButton
      variant="warning"
      size="xs"
      iconSrc="sign-out-alt"
      content="Sign this user out of all active sessions. They'll need to sign in again."
      confirmContent={
        confirmDescription ??
        "Are you sure you want to revoke all sign-in sessions for this user?"
      }
      isSquare={!children}
      isLoading={loading}
      onConfirm={() => {
        revokeSessions({ variables: { id: userId } })
      }}
      {...rest}
    >
      {children}
    </ConfirmButton>
  )
}

export default UserRevokeSessionsButton
